import { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./App.css";

const USERNAME = "admin";
const PASSWORD = "admin";

const sdk = new window.sfdc.BlockSDK();

function App() {
	const [loggedIn, setLoggedIn] = useState(false);
	const [error, setError] = useState("");
	const [value, setValue] = useState("");
	const [loading, setLoading] = useState(true);

	const login = () => {
		localStorage.setItem("loggedIn", true);
		setLoggedIn(true);
	};

	const logout = () => {
		setLoggedIn(false);
		setError("");
		localStorage.removeItem("loggedIn");
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();

		const username = e.target[0].value;
		const password = e.target[1].value;

		if (username === USERNAME && password === PASSWORD) {
			setError("");
			login();
		}

		setError("Invalid username or password");

		return false;
	};

	const handleEditorChange = (value) => {
		setValue(value);

		sdk.setContent(value);
	};

	useEffect(() => {
		sdk.getContent((content) => {
			setValue(content);
		});

		const loggedIn = localStorage.getItem("loggedIn");

		if (loggedIn) {
			setLoggedIn(true);
		}

		setLoading(false);
	}, []);

	if (loading) {
		return <h1>Loading...</h1>;
	}

	if (!loggedIn) {
		return (
			<div>
				<h1>Login</h1>
				<form onSubmit={handleFormSubmit}>
					<input type="text" placeholder="Username" />
					<br />
					<input type="password" placeholder="Password" />
					<br />
					<input type="submit" value="Login" />
					{error && <p style={{ color: "red" }}>{error}</p>}
				</form>
			</div>
		);
	}

	const count = localStorage.getItem("count") || 0;

	localStorage.setItem("count", parseInt(count) + 1);

	return (
		<div>
			<h1>Count: {count}</h1>
			<ReactQuill theme="snow" value={value} onChange={handleEditorChange} />
			<button onClick={logout}>Logout</button>
		</div>
	);
}

export default App;
